<script>
  import { fade } from "svelte/transition";
  import About from "./About.svelte";
  import MyWorkout from "./MyWorkout.svelte";
  import TopWods from "./TopWods.svelte";
  import { fly } from "svelte/transition";
  import { createEventDispatcher } from "svelte";

  export let isWorkoutStarted;
  export let pause = false;
  export let done;

  const dispatch = createEventDispatcher();

  let menuOpen = false;

  const navOptions = [
    { page: "My Workout", component: MyWorkout },
    { page: "Top WODs", component: TopWods },
    { page: "About", component: About },
  ];

  let selected = navOptions[0];
  let intSelected = 0;

  function changeComponent(event) {
    selected = navOptions[event.srcElement.id];
    intSelected = event.srcElement.id;
  }

  function finish() {
    pause = false;
    dispatch("finish");
  }
</script>

<div class="fixed right-0 bottom-0 sm:bottom-auto sm:top-0 text-white z-40 m-2">
  {#if isWorkoutStarted}
    {#if pause || done}
      <button
        aria-label="finish"
        in:fly={{ x: 30 }}
        on:click={finish}
        class="bg-gray-800 focus:outline-none focus:bg-gray-700 rounded-full p-2"
      >
        <svg class="w-10 h-10 fill-current" viewBox="0 0 24 24">
          <path
            d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
          />
        </svg>
      </button>
    {/if}
    {#if !done}
      <button
        aria-label="Pause"
        on:click={() => (pause = !pause)}
        class="bg-gray-800 focus:outline-none focus:bg-gray-700 rounded-full p-2"
      >
        {#if pause}
          <svg class="w-10 h-10 fill-current" viewBox="0 0 24 24">
            <path d="M7 6v12l10-6z" />
          </svg>
        {:else}
          <svg class="w-10 h-10 fill-current" viewBox="0 0 24 24">
            <path d="M8 7h3v10H8zm5 0h3v10h-3z" />
          </svg>
        {/if}
      </button>
    {/if}
  {:else}
    <button
      on:click={() => (menuOpen = !menuOpen)}
      aria-label="Open menu"
      class="bg-black focus:outline-none focus:bg-gray-800 rounded-full p-2"
    >
      {#if !menuOpen}
        <svg class="w-10 h-10 fill-current" viewBox="0 0 24 24">
          <path d="M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z" />
        </svg>
      {:else}
        <svg class="w-10 h-10 fill-current" viewBox="0 0 24 24">
          <path
            d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
          />
        </svg>
      {/if}
    </button>
  {/if}
</div>
<aside
  class="transform top-0 right-0 w-10/12 md:w-1/2 lg:w-1/3 bg-black bg-opacity-50 fixed h-full overflow-auto ease-in-out transition-all duration-200 z-30 p-2"
  class:translate-x-full={!menuOpen}
  class:translate-x-0={menuOpen}
>
  <nav class="flex">
    {#each navOptions as option, i}
      <button
        on:click={changeComponent}
        aria-label="Go to"
        id={i}
        class={intSelected == i
          ? "uppercase text-xs py-2 px-2 block hover:text-blue-500 focus:outline-none text-blue-500 border-b-2 font-medium border-blue-500"
          : "uppercase text-xs text-gray-600 py-2 px-2 block hover:text-blue-500 focus:outline-none"}
      >
        {option.page}
      </button>
    {/each}
  </nav>
  <svelte:component this={selected.component} {...selected.setup} />
</aside>

{#if menuOpen}
  <div
    transition:fade={{ duration: 200 }}
    on:click={() => (menuOpen = !menuOpen)}
    class="fixed inset-0 bg-gray-800 opacity-70 z-10"
    tabindex="0"
  />
{/if}
